export enum VelthuisFormStep {
  SelectCategory = 'select_category',
  SelectAppointmentType = 'select_appointment_type',
  SelectClinic = 'select_clinic',
  SelectDoctor = 'select_doctor',
  SelectDateTime = 'select_date_time',
  ProposedAppointment = 'proposed_appointment',
  ConfirmBooking = 'confirm_booking',
  PatientDetails = 'fill_patient_details',
  AppointmentConfirmed = 'appointment_confirmed',
  MoreInformation = 'more_information',
  HealthWarning = 'health_warning',
  BMIHigh = 'bmi_high',
}
